module.exports = __webpack_public_path__ + "img/video.8ff62215.svg";